import { useContext } from 'react';
import { ConfigContext } from '@common/Config';

export const useConfig = () => useContext(ConfigContext);
